import { Input } from '@presentation/components/molecules'
import { InputProps } from '@presentation/types/components/molecules'

const DescriptionInput: React.FC<InputProps> = ({ type, name, register }) => {
  return <Input type={type} name={name} register={register} required />
}

export default DescriptionInput
